import type { ExternalTableSchema } from '@packages/table-builder';

export const disbursementDashboardTable: ExternalTableSchema = {
  metadata: {
    title: 'Disbursement Dashboard',
    entity: 'DisbursementDashboard',
    description: 'Disbursement dashboard grouped by company.',
  },

  dataSource: {
    endpoint: '/api/award-settlement/api/app/disbursement/disbursement-dashboard',
    method: 'GET',
    rowIdField: 'id',
    requestParams: {
      CompanyIds: 'filters.companyIds',
      DisbursementContainerStatusId: 'filters.disbursementContainerStatusIds',
      DisbursementStatusId: 'filters.disbursementStatusIds',
    },
    filters: [
      {
        name: 'companyIds',
        semanticId: 'companyIds',
        placeholder: 'Company',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/customer/api/app/participant-broker-account/company-list',
          labelField: 'companyName',
          valueField: 'id',
        },
      },
      {
        name: 'disbursementContainerStatusIds',
        semanticId: 'disbursementContainerStatusIds',
        placeholder: 'Container Status',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/award-settlement/api/app/disbursement/disbursement-container-status',
          labelField: 'name',
          valueField: 'id',
        },
      },
      {
        name: 'disbursementStatusIds',
        semanticId: 'disbursementStatusIds',
        placeholder: 'Disbursement Status',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/award-settlement/api/app/disbursement/disbursement-item-status',
          labelField: 'name',
          valueField: 'id',
        },
      },
    ],
  },

  columns: [
    {
      field: 'company',
      header: 'Company Name',
      type: 'text',
      width: 200,
    },
    {
      field: 'brokerage',
      header: 'Brokerage',
      type: 'text',
      width: 200,
    },
    {
      field: 'ticker',
      header: 'Ticker',
      type: 'text',
      width: 150,
    },
    {
      field: 'containerStatus',
      header: 'Container Status',
      type: 'badge',
      width: 180,
      align: 'center',
      badge: {
        statusMap: {
          Pending: 'info',
          Processing: 'info',
          Completed: 'success',
          Failed: 'error',
          Cancelled: 'default',
        },
        defaultVariant: 'info',
      },
    },
    {
      field: 'disbursementStatus',
      header: 'Disbursement Status',
      type: 'badge',
      width: 200,
      align: 'center',
      badge: {
        statusMap: {
          Pending: 'info',
          Processing: 'info',
          Completed: 'success',
          Failed: 'error',
          Cancelled: 'default',
        },
        defaultVariant: 'info',
      },
    },
    {
      field: 'depositAmount',
      header: 'Deposit Amount',
      type: 'number',
      width: 180,
      align: 'center',
      format: { decimals: 2, fixed: true },
    },
  ],

  actions: {
    row: [{ id: 'VIEW_DETAILS_DISBURSEMENT', label: 'View Details' }],
  },

  features: {
    search: { enabled: false },
    pagination: { mode: 'none' },
    groupBy: {
      fields: ['company'],
      expandMode: 'expanded',
      hideGroupedColumn: false,
    },
    columnPreferences: { persistenceKey: 'disbursementDashboard', resizable: true },
  },
};
